import lodash from 'lodash'
import Status from '@/status'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
export default {
  name: 'edit',
  components: {Datetime},
  props: [],
  data () {
    return {
      normalizer (node) {
        return {
          id: node.id,
          label: node.fullname + ' (' + node.email + ')',
          children: node.children
        }
      },
      normalizer_org (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      normalizer_ctg (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      loading: true,
      checklist: {
        user: []
      },
      btn_submit: false,
      errors: {},
      users_group: []
    }
  },
  computed: {
    category () {
      return this.$store.getters['CategoryChk/getListRecursive']
    },
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    },
    group_aliases () {
      return this.$store.getters['GroupAlias/getListGroupAlias']
    },
    users: {
      get: function () {
        return this.$store.getters['User/users']
      },
      set: function (value) {
        this.$store.commit('User/setData', value)
      }
    }
  },
  mounted () {
    this.loading = true
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('Organization/getData', {page: 1, per_page: 'all', status: Status.APPROVAL}),
      this.$store.dispatch('GroupAlias/getListGroupAlias', {per_page: 500}),
      this.$store.dispatch('User/getData', {per_page: 'all', status: 0}),
      this.$store.dispatch('Checklist/showChecklist', {checklist: {id: this.$route.params.checklist_id}}),
      this.$store.dispatch('Audit/getUserOfChecklist', {checklist: {id: this.$route.params.checklist_id}}),
      this.$store.dispatch('CategoryChk/getListCtg'),
    ]).then(res => {
      this.checklist = res[3]
      this.checklist.user = []
      this.checklist.org_id = res[3].organization.id
      res[1].forEach(element => {
        this.users_group[element.id] = {users: [], plus_users: []}
      })
      res[4].forEach(element => {
        element.users.forEach(user => {
          var index = lodash.findIndex(this.users, ['id', user.id])
          this.users.splice(index, 1)
        })
        this.users_group[element.id] = {users: element.users, plus_users: []}
      })
      this.loading = false
      this.$loading.complete()
    }).catch(errors => {
      this.loading = false
      this.$loading.fail()
    })
  },
  methods: {
    select (index, node) {
      var i = lodash.findIndex(this.users, ['id', node.id])
      this.users.splice(i, 1)
      this.users_group[index].plus_users.push(node)
    },
    deselect (index, node) {
      var i = lodash.findIndex(this.users_group[index].plus_users, ['id', node.id])
      this.users_group[index].plus_users.splice(i, 1)
      this.users.push(node)
    },
    destroyUser (index, user) {
      var i = lodash.findIndex(this.users_group[index].users, ['id', user.id])
      this.users_group[index].users.splice(i, 1)
      this.users.push(user)
    },
    update () {
      var user = []
      this.users_group.forEach((element, index) => {
        if (element) {
          var uids = []
          element.users.concat(element.plus_users).forEach(user => {
            uids.push(user.id)
          })
          user.push({
            group_alias_id: index,
            users: uids
          })
        }
      })
      this.checklist.users = user
      this.$loading.start()
      this.btn_submit = true
      this.checklist.starting_date = this.checklist.starting_date ? this.$moment(this.checklist.starting_date).format('YYYY-MM-DD') : ''
      this.checklist.ending_date = this.checklist.ending_date ? this.$moment(this.checklist.ending_date).format('YYYY-MM-DD') : ''
      this.checklist.ctg == undefined? this.checklist.ctg=this.checklist.category.id : this.checklist.ctg
      delete this.checklist.status
      this.$store.dispatch('Checklist/updateChecklist', {checklist: this.checklist}).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        this.$router.push('../list')
        this.$loading.complete()
        this.btn_submit = false
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
        this.btn_submit = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/edit/edit.js